<template>
  <div
    class="page--employee"
    :style="`min-height: ${height}px`"
  >
    <Header />
    <Form />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Header from 'components/revenuesNfeImport/Header'
import Form from 'components/revenuesNfeImport/Form'

export default {
  name: 'RevenuesNfeImportPage',
  components: {
    Header,
    Form
  },
  computed: {
    height () {
      return document.body.offsetHeight
    }
  },
  data () {
    return {
      namespace: 'Views.RevenuesPage',
      currentStatus: null
    }
  },
  methods: {
    ...mapActions({
      errorAlert: 'snackbarAlert/error'
    }),

    handleSubmit () {
      this.submitForm = !this.submitForm
    }
  }
}
</script>
